

import React, { Component } from 'react';
// import SupportingText from '../../common/supportingText/SupportingText';
import ClientsPageContainer from '../../components/clients/containers/ClientsPageContainer';
import HeaderTags from '../../common/headerTags/HeaderTags';
import { getClientsDataIfNeeded } from '../../components/clients/actions/clientsActions';

const headerTags = {
    title: 'Clientes - Conheça nossos clientes', // max 60 char in total, ' | Antena 1' (11 chars) is automatically added by the Headers Tag and is truncated
    meta: {
        description: 'Conheça mais sobre os clientes que anunciam online e offline com a Antena 1.',
        keywords: 'anuncio, comercial, cliente, propaganda, empresa, agencia',
        'og:title': 'Clientes - Conheça nossos clientes',
        'og:description': 'Conheça mais sobre os clientes que anunciam online e offline com a Antena 1.',
        'og:image': 'https://a1media.antena1.com.br/image/share/clientes.png',
    },
};

// const supportingTextInfo = {
//     title: 'Clientes - Saiba quem anuncia na Antena 1',
//     description: `A Antena 1, uma das rádios mais influentes e significativas do país, se orgulha do seu portfolio de clientes.
//         Todos são especiais e fazem parte da nossa história. Sempre fazemos essa seleção de parceiros também pensando nos nossos ouvintes,
//         buscando atender com excelência e direcionando os anúncios ao público certo.
//         As melhores relações, são construídas a base de confiança, empenho e muita dedicação, temos orgulho de construir a nossa marca junto com os nossos parceiros.
//         Agradecemos aos nossos clientes por acreditar no nosso trabalho e ajudar a construir essa história junto com as nossas 25 rádios,
//         espalhadas pelas maiores capitais do Brasil.`,
// };

class Clientes extends Component {
    static fetchData(store) {
        return store.dispatch(getClientsDataIfNeeded());
    }

    render() {
        return (
            <div className="pageWrapper tw-container tw-mx-auto tw-px-5">
                <HeaderTags title={headerTags.title} meta={headerTags.meta} />
                <ClientsPageContainer />
                {/* <SupportingText title={supportingTextInfo.title} description={supportingTextInfo.description} /> */}
            </div>
        );
    }
}

export default Clientes;
